// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__hCrDR","left":"StickyBox_left__2QUMk","right":"StickyBox_right__3MmW4"};